import {css} from 'styled-components';

// For ReactMarkdown
const markdownStyles = css`
    /* https://github.com/remarkjs/react-markdown/issues/35 */
    ul, ol {
        white-space: normal;
        -webkit-padding-start: revert;
        list-style: revert;
    }

    table, th, td {
        border-collapse: collapse;
        border: 1px solid black;
    }

    blockquote {
        padding-left: 1em;
        margin: 0;
        color: var(--neutralDarker);
        background: var(--neutralLightest);
        border-left: 0.3em var(--neutral) solid;
    }

    code {
        padding: 0 7px;
        background: var(--neutralLight);
    }
`;

export const TopbarNotificationModalStyled = css`
  .notification-popover {
    .ant-popover-arrow {
      @media only screen and (width <= 500px) {
        display: none;
      }
    }

    .ant-popover-content .ant-popover-inner {
      padding: 0;

      .ant-popover-inner-content {
        padding: 12px 0;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }

    @media only screen and (width <= 767px) {
      max-width: 420px;
    }
    
    @media only screen and (width <= 575px) {
      right: 20px;
    }
  }
  
  .notification-modal-content {
    white-space: pre-line;

    p {
      padding-top: 0;
    }

    ${markdownStyles}
  }
`;
